import { CollectionElement } from '@typedream/core';
import { CMSPresetColumnType } from '@typedream/data';

import {
  BracketsCurly,
  CalendarBlank,
  CaretCircleDown,
  CheckSquare,
  Hash,
  Image,
  Link,
  ListBullets,
  TextAlignLeft,
  TextT,
} from 'phosphor-react';

export const CMSTemplates: { [key: string]: CollectionElement['collection_template'] } = {
  td_cms_columns: {
    databaseTemplateURL: undefined,
    previewImage: undefined,
    custom: false,
    templateKey: 'td_cms_columns',
    schema: {
      title: 'title',
      date: 'date',
      image_url: 'image',
    },
    schemaOrder: ['title', 'date', 'image_url'],
    settings: {
      numCol: 3,
    },
    template: {
      type: 'container',
      background: 'default',
      align: 'align_center',
      children: [
        {
          type: 'img',
          children: [
            {
              id: '4f95a096-dd89-4a31-9770-5caa65619085',
              text: '',
            },
          ],
          url: 'https://api.typedream.com/v0/document/public/06acde81-5a0d-4f50-a48d-eaf4fbc08f8b/2UKkJWvDgmZiA2bBDLXX2f0tRE1_philip-jahn-PYkpulrIMG0-unsplash_Medium.jpeg',
          width: 708,
          height: 472.36874999999975,
          aspect_ratio: 1.4988290398126471,
          border_radius: '10px',
          id: '4f95a096-dd89-4a31-9770-5caa65619985',
          collection_connect_data: true,
          objectFit: 'cover',
          collection_connect_data_keys: [
            {
              blockElementKey: 'url',
              schemaKey: 'image_url',
            },
          ],
        },
        {
          type: 'p',
          id: '33f3beca-b5c7-4599-b609-5526ae3b7385',
          children: [
            {
              bold: true,
              text: 'Digital Products 101',
              collection_connect_data: true,
              collection_connect_data_keys: [
                {
                  blockElementKey: 'text',
                  schemaKey: 'title',
                },
              ],
            },
          ],
        },
        {
          type: 'p',
          id: '00391d9c-6a68-45e3-834b-18351493554f',
          children: [
            {
              text: 'June 25',
              styled: true,
              color: 'gray',
              gradient: false,
              collection_connect_data: true,
              collection_connect_data_keys: [
                {
                  blockElementKey: 'text',
                  schemaKey: 'date',
                },
              ],
            },
          ],
        },
      ],
      id: '42d9393a-58f2-4c56-9abe-e78b5fd6e377',
      width: 700,
    },
  },
  td_cms_rows: {
    databaseTemplateURL: undefined,
    previewImage: undefined,
    custom: false,
    templateKey: 'td_cms_rows',
    schema: {
      title: 'title',
      date: 'date',
      image_url: 'image',
    },
    schemaOrder: ['title', 'date', 'image_url'],
    settings: {
      numCol: 1,
    },
    template: {
      type: 'container',
      background: 'default',
      align: 'align_center',
      children: [
        {
          type: 'column',
          children: [
            {
              type: 'column_item',
              children: [
                {
                  type: 'img',
                  children: [
                    {
                      id: 'b48dee30-8e57-4a2f-b760-1c506133a77a',
                      text: '',
                    },
                  ],
                  url: 'https://api.typedream.com/v0/document/public/06acde81-5a0d-4f50-a48d-eaf4fbc08f8b/2UKkJWvDgmZiA2bBDLXX2f0tRE1_philip-jahn-PYkpulrIMG0-unsplash_Medium.jpeg',
                  width: 184.1667886416862,
                  height: 122.87377929687493,
                  aspect_ratio: 1.4988290398126471,
                  border_radius: '10px',
                  objectFit: 'cover',
                  collection_connect_data: true,
                  collection_connect_data_keys: [
                    {
                      blockElementKey: 'url',
                      schemaKey: 'image_url',
                    },
                  ],
                  id: 'b48dee30-8e57-4a2f-b760-1c596133a77a',
                },
              ],
              width: 0.3059375,
              id: '028d8250-9b09-4c2e-b53c-ba2b430f7d01',
            },
            {
              type: 'column_item',
              children: [
                {
                  type: 'p',
                  id: '33f3beca-b5c7-4599-b609-5526ae3b7385',
                  children: [
                    {
                      bold: true,
                      text: 'How to build a digital creator business',
                      collection_connect_data: true,
                      collection_connect_data_keys: [
                        {
                          blockElementKey: 'text',
                          schemaKey: 'title',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'p',
                  id: '00391d9c-6a68-45e3-834b-18351493554f',
                  children: [
                    {
                      text: 'June 25',
                      styled: true,
                      color: 'gray',
                      gradient: false,
                      collection_connect_data: true,
                      collection_connect_data_keys: [
                        {
                          blockElementKey: 'text',
                          schemaKey: 'date',
                        },
                      ],
                    },
                  ],
                },
              ],
              width: 0.5214285714285715,
              id: 'c49b54c1-c66c-4104-b089-0525bf1fa7ff',
            },
          ],
          id: 'c33d5d87-e5ec-4bc7-a57d-b9ee73970a46',
          align: 'align_left',
          width_max: '100%',
        },
      ],
      id: '42d9393a-58f2-4c56-9abe-e78b5fd6e377',
      width: 700,
    },
  },
};

export const CMSColumnTypeIcons: { [key in CMSPresetColumnType | 'slug']: React.ReactNode } = {
  selection: <CaretCircleDown size={16} />,
  multiselection: <ListBullets size={16} />,
  text: <TextT size={16} />,
  number: <Hash size={16} />,
  date: <CalendarBlank size={16} />,
  image: <Image size={16} />,
  boolean: <CheckSquare size={16} />,
  rich_text: <TextAlignLeft size={16} />,
  url: <Link size={16} />,
  object: <BracketsCurly size={16} />,
  slug: <div className="flex items-center justify-center text-base leading-none w-4 h-4">/</div>,
};

export const CMSColumnTypeName: { [key in CMSPresetColumnType | 'slug']: string } = {
  selection: 'Selection',
  multiselection: 'Multi-selection',
  text: 'Text',
  number: 'Number',
  date: 'Date',
  image: 'Image',
  boolean: 'Checkbox',
  rich_text: 'Rich Text',
  url: 'URL',
  object: 'Object',
  slug: 'Text',
};
